import { IIconColorProps } from "../../interfaces/IIconProps";

export default ({ color }: IIconColorProps) => (
    <svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.625 15.5833V13.8125L5.66667 11.3333H2.125V7.08329H5.17083L7.08333 4.88746V1.41663H11.3333V5.66663H8.2875L6.375 7.86246V10.0937L10.625 12.2187V11.3333H14.875V15.5833H10.625ZM8.5 4.24996H9.91667V2.83329H8.5V4.24996ZM3.54167 9.91663H4.95833V8.49996H3.54167V9.91663ZM12.0417 14.1666H13.4583V12.75H12.0417V14.1666Z" fill={color} />
    </svg>
);